import { Box, Typography } from '@mui/material';
import { Dialog } from 'components/commons';
import { FC } from 'react';

interface ConfirmDeleteDialogProps {
  open: boolean;
  handleClose: () => void;
  confirmTitle: string;
  confirmContent: string;
  handleConfirm: () => void;
}

const ConfirmDeleteDialog: FC<ConfirmDeleteDialogProps> = ({
  open,
  handleClose,
  confirmTitle,
  confirmContent,
  handleConfirm,
}) => {
  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      title={confirmTitle}
    >
      <Box padding='15px 6px'>
        <Typography
          sx={{ fontSize: { xs: '18px', sm: '22px' }, textAlign: 'center' }}
        >
          {confirmContent}
        </Typography>
      </Box>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
